import {
  AppDialog,
  AppDialogActions,
  AppDialogCancelButton,
  AppDialogContent,
  AppDialogTitle,
} from "../../../components/dialog";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppCustomStyles } from "../../../assets/theme/custom/hooks";

type Props = {
  open: boolean;
  indexName?: string;
  draftTitle?: string;
  analysisText: string;
  loading?: boolean;
  title?: string;
  onClose: () => void;
};

export default function GuideAnalysisViewDialog({
  open,
  indexName,
  draftTitle,
  analysisText,
  loading,
  title,
  onClose,
}: Props) {
  const { t } = useTranslation();
  const custom = useAppCustomStyles();

  return (
    <AppDialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <AppDialogTitle>
        {title || t("guide.viewAnalysis")}
        {indexName && (
          <Typography variant="caption" color="text.secondary" display="block">
            {draftTitle ? `${draftTitle} · ${indexName}` : indexName}
          </Typography>
        )}
      </AppDialogTitle>
      <AppDialogContent>
        {loading ? (
          <Typography variant="body2" color="text.secondary">
            {t("common.loading")}
          </Typography>
        ) : (
          <Box component="pre" sx={custom.components.guide.analysisViewBody}>
            {analysisText || t("guide.analysisEmpty")}
          </Box>
        )}
      </AppDialogContent>
      <AppDialogActions>
        <AppDialogCancelButton onClick={onClose}>{t("common.close")}</AppDialogCancelButton>
      </AppDialogActions>
    </AppDialog>
  );
}
